import './investment-calculator-block';